module.exports = __webpack_public_path__ + "img/1.9859e800.jpg";